
import { Component, Prop, Vue, } from 'vue-property-decorator';

@Component
export default class LandingSection extends Vue {
	@Prop({
		required: true,
		type: Array,
	})
	items!: readonly string[];

	hasSlot(itemName: string) {
		return !!this.$slots[itemName];
	}
}
